module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/faq-hero-mobile-2024-bb47865482321b9fe2b255ee62213697.webp";